export default __webpack_public_path__ + "static/laptopmock2-dbab6673ad874d04eeded0c3b64a892a.png";